module.exports = __webpack_public_path__ + "./docs/img/big-icon-events.b0dc3d2357b3723703c2596188f576b4.svg";